"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Collapsable = _interopRequireDefault(require("../Collapsable"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
// Left sidebar with filters rendered based on AppDefs
var FilterSideBar = /*#__PURE__*/function (_React$Component) {
  _inherits(FilterSideBar, _React$Component);
  var _super = _createSuper(FilterSideBar);
  function FilterSideBar() {
    var _this;
    _classCallCheck(this, FilterSideBar);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "getTagLabel", function (tag) {
      var result = _this.props.filterTags.find(function (item) {
        return item.name === tag;
      });
      return result ? result.label : tag;
    });
    return _this;
  }
  _createClass(FilterSideBar, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        filterGroups = _this$props.filterGroups,
        filters = _this$props.filters,
        filterUpdater = _this$props.filterUpdater,
        displayOptions = _this$props.displayOptions;
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("h3", {
        style: {
          color: displayOptions.portal && displayOptions.portal.filterHeaderColor || 'inherit',
          backgroundColor: displayOptions.portal && displayOptions.portal.filterHeaderBackgroundColor || 'initial'
        },
        className: _style["default"].header
      }, "Filter by Criteria"), filterGroups.map(function (group, gIndex) {
        return /*#__PURE__*/_react["default"].createElement(_Collapsable["default"], {
          key: gIndex,
          title: group.name,
          icon: group.icon,
          color: group.color,
          collapsible: group.collapsible,
          isCollapsed: group.isCollapsed,
          displayOptions: displayOptions,
          getTagLabel: _this2.getTagLabel
        }, /*#__PURE__*/_react["default"].createElement("div", {
          style: displayOptions.portal && displayOptions.portal.filterGroupColor ? {
            backgroundColor: displayOptions.portal.filterGroupColor,
            color: displayOptions.portal.filterGroupTextColor
          } : {
            color: displayOptions.portal.filterGroupTextColor
          },
          className: 'form-check ' + _style["default"].filters
        }, group.tags.map(function (tag) {
          return /*#__PURE__*/_react["default"].createElement("div", {
            key: tag,
            className: "checkbox"
          }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("input", {
            onChange: function onChange() {
              return filterUpdater(tag);
            },
            className: "form-check-input",
            type: "checkbox",
            checked: filters.includes(tag)
          }), _this2.getTagLabel(tag)));
        })));
      }));
    }
  }]);
  return FilterSideBar;
}(_react["default"].Component);
exports["default"] = FilterSideBar;
_defineProperty(FilterSideBar, "propTypes", {
  filterGroups: _propTypes["default"].array.isRequired,
  filterTags: _propTypes["default"].array.isRequired,
  filterUpdater: _propTypes["default"].func.isRequired,
  filters: _propTypes["default"].array.isRequired,
  displayOptions: _propTypes["default"].object
});